export const AFFILIATE_DASHBOARD_API = '/api/dashboard/affiliate-dashboard'
